// Legacy monolito (noveltymasterstartup) - en desuso, se mantiene solo para lo que todavía no
// tiene equivalente en pd-api (ver GET_BUSINESS_BY_ID_ENDPOINT más abajo).
const WS = 'https://web.practiday.com/PractidayMaster/ws' // prod
// const WS = "http://localhost:8090/PractidayMaster/ws"; // local
// const WS = "https://dev.blackhorse.ec/PractidayMaster/ws"; // dev

// Nueva base pública (sin JWT) expuesta por pd-api, que reemplaza al "WSPlanes" de pagos del
// monolito. Ver pd-api: PagosPublicController (/v1/public/pagos/**).
const PAGOS_WS = 'https://services.practiday.com/v1/public/pagos' // prod
// const PAGOS_WS = "http://localhost:18080/v1/public/pagos"; // local (pd-api)

export const EMPRESA_ENDPOINT = WS + "/planes/empresa"; // no usado (Plans.jsx no está enrutado)

export const GET_PLANS_ENDPOINT = `${PAGOS_WS}/planes`;
export const GET_PLAN_BY_UUID_ENDPOINT = `${PAGOS_WS}/planes`;
export const CREATE_PAYPHONE_TRANSACTION_ENDPOINT = `${PAGOS_WS}/transactions`;
export const GET_BUSINESS_BY_EMAIL = `${PAGOS_WS}/cuentas/correo`;
// Cuenta por pdAccountId (UUID de la suscripción), usado cuando pd-web redirige con la sesión.
export const GET_BUSINESS_BY_PD_ACCOUNT_ID = `${PAGOS_WS}/cuentas`;

// TODO(migración): sin equivalente en pd-suscripciones-ms. El modelo nuevo identifica cuentas por
// pdAccountId (UUID) o correo, no por el id numérico autoincremental del monolito. Si todavía hay
// enlaces externos (ej. correos, o el propio Practiday) que apuntan a
// /business/:businessId con el id legacy, hay que decidir cómo resolverlos (¿migrar guardando el
// id legacy en algún lado, o regenerar esos enlaces con pdAccountId/correo?) antes de apagar
// noveltymasterstartup. Mientras tanto sigue apuntando al monolito.
export const GET_BUSINESS_BY_ID_ENDPOINT = `${WS}/empresas/id`;

export const REGISTRO_PRACTIDAY_ENDPOINT =
  "https://web.practiday.com/Practiday/registro/";
export const LOGIN_PRACTIDAY_ENDPOINT =
  "https://web.practiday.com/Practiday/login/";